import React, { useEffect, useState } from "react";

import { Provider, useSelector } from "react-redux";
import {
  FbThemeProvider,
  FbcreateMuiTheme,
  FbNoResponse,
} from "@flexibees/core";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import { hot } from "react-hot-loader/root";
import { default as ThemeConfig } from "./config/theme";
import store from "./store";
import ProtectedRoute from "./components/utilities/protectedRoute";
import AuthRoutes from "./routes/auth";
import AdminRoutes from "./routes/admin";
import AppSettingsRoute from "./routes/appSettings";
import { SnackbarProvider } from "notistack";
import { MAX_STACK_COUNT } from "./constants/common";
import SnackAlert from "./components/utilities/SnackAlert";
import { ErrorBoundary } from "react-error-boundary";

const flexibeeTheme = FbcreateMuiTheme(ThemeConfig);

const ProviderConfig = () => {
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    let unmounted = false;
    if (!unmounted) {
      setPath(window.location.pathname);
    }
    // eslint-disable-next-line no-return-assign
    return () => (unmounted = true);
  }, [setPath]);

  return (
    <FbThemeProvider theme={flexibeeTheme}>
      <Router basename={process.env.PUBLIC_URL}>
        {!isLoggedIn ? (
          <Switch>
            <Route
              exact={path === "/app-settings"}
              path="/"
              component={AuthRoutes}
            />
            <Route path={`/app-settings`} component={AppSettingsRoute} />
          </Switch>
        ) : (
          <ProtectedRoute path="/admin" component={AdminRoutes} />
        )}
        {isLoggedIn &&
          (path === process.env.PUBLIC_URL ||
            path === `${process.env.PUBLIC_URL}/` ||
            path === `${process.env.PUBLIC_URL}/admin`) && (
            <Redirect to="/admin/dashboard" />
          )}
      </Router>
    </FbThemeProvider>
  );
};

const ErrorFallback = () => (
  <FbNoResponse
    errorCode="Error"
    errorMessage="Something went wrong"
  />
);

function App() {
  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
    >
      <Provider store={store}>
        <SnackbarProvider
          maxSnack={MAX_STACK_COUNT}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <SnackAlert />
          <ProviderConfig />
        </SnackbarProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default hot(App);
